import { useSanctumConfig } from "../../composables/useSanctumConfig.js";
import {
  useCookie,
  useRequestHeaders,
  useRequestURL
} from "#app";
const SECURE_METHODS = /* @__PURE__ */ new Set(["post", "delete", "put", "patch"]);
const COOKIE_OPTIONS = { readonly: true };
function buildServerHeaders(headers, config) {
  const clientCookies = useRequestHeaders(["cookie"]);
  const origin = config.origin ?? useRequestURL().origin;
  return {
    ...headers,
    Referer: origin,
    Origin: origin,
    ...clientCookies.cookie && clientCookies
  };
}
async function initCsrfCookie(config, logger) {
  await $fetch(config.endpoints.csrf, {
    baseURL: config.baseUrl,
    credentials: "include"
  });
  logger.debug("CSRF cookie has been initialized");
}
async function useCsrfHeader(headers, config, logger) {
  let csrfToken = useCookie(config.csrf.cookie, COOKIE_OPTIONS);
  if (!csrfToken.value) {
    await initCsrfCookie(config, logger);
    csrfToken = useCookie(config.csrf.cookie, COOKIE_OPTIONS);
  }
  if (!csrfToken.value) {
    logger.warn(
      `${config.csrf.cookie} cookie is missing, unable to set ${config.csrf.header} header`
    );
    return headers;
  }
  logger.debug(`Added ${config.csrf.header} header to pass to the API`);
  return {
    ...headers,
    ...csrfToken.value && {
      [config.csrf.header]: csrfToken.value
    }
  };
}
export default async function handleRequestCookies(app, ctx, logger) {
  const config = useSanctumConfig();
  const method = ctx.options.method?.toLowerCase() ?? "get";
  if (import.meta.server) {
    ctx.options.headers = buildServerHeaders(ctx.options.headers, config);
  }
  if (SECURE_METHODS.has(method)) {
    ctx.options.headers = await useCsrfHeader(
      ctx.options.headers,
      config,
      logger
    );
  }
}
